module.exports = __webpack_public_path__ + "static/media/Javad_Hosseinzadeh.4c9cd24b.jpg";